module.exports = __webpack_public_path__ + "media/lucky_anim1.ea3776d0.mp3";